import { ModalViewModel } from '@/infra/ModalViewModel'
import { action, observable } from 'mobx'
import { Section7216 } from '@/features/account/section-7216/Section7216'
import { type Id } from '@/infra/id'
import type { Section7216Store } from '@/features/account/section-7216/Section7216Store'

export class ViewAcceptedSection7216DialogViewModel {
  readonly modal = new ModalViewModel()

  @observable accessor section7216: Section7216 = Section7216.none
  @observable accessor userSignature = ''
  @observable accessor spouseSignature = ''
  @observable accessor dateAccepted: Date = new Date()

  constructor(private readonly _store: Section7216Store) {}

  @action.bound
  async view(
    id: Id,
    userSignature: string,
    spouseSignature: string | null,
    dateAccepted: Date,
  ) {
    const section7216 = await this._store.fetchById(id)
    this.section7216 = section7216
    this.userSignature = userSignature
    this.spouseSignature = spouseSignature ?? ''
    this.dateAccepted = dateAccepted
    this.modal.show()
  }
}
